import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import React, { FC, ReactNode, useContext, useEffect, useRef } from 'react'
import s from './AdvDetailedButton.module.sass'
import { AdvDetailedContext } from '@features/Common/AdvDetailed/Context'
import IconDots from '@icons/icon-three-dots.svg'
import IconClose from '@icons/icon--x.svg'
import { Tooltip } from '@shared/ui/Overlays/Tooltip'

interface Props {
  children?: ReactNode
  className?: string
  iconChange?: boolean // true - при клике иконка троеточия меняется на крестик, false - всегда троеточие
  onOpen?: () => void
  onClose?: () => void
}

const AdvDetailedButton: FC<Props & React.ButtonHTMLAttributes<any>> = ({
  children,
  className = '',
  iconChange = true,
  onOpen,
  onClose,
  ...props
}) => {
  // @ts-ignore
  const [context, setContext] = useContext(AdvDetailedContext)
  const refButton = useRef()

  const handleChangeOpen = (e) => {
    if (context.opened) {
      setContext((prev) => ({ ...prev, opened: false }))
      onClose && onClose()
    } else {
      setContext((prev) => ({ ...prev, opened: true }))
      onOpen && onOpen()
    }
  }

  useEffect(() => {
    if (refButton.current && !context.floatingRelative)
      setContext((prev) => ({ ...prev, floatingRelative: refButton.current }))
  }, [])

  return (
    <ErrorBoundary>
      <Tooltip.Trigger>
        <div ref={refButton} className={`${s.wrapper} ${className}`} {...props} onClick={handleChangeOpen}>
          {children || (
            <button className={s.button}>{iconChange && context.opened ? <IconClose /> : <IconDots />}</button>
          )}
        </div>
      </Tooltip.Trigger>
    </ErrorBoundary>
  )
}

export default AdvDetailedButton
